import { ExpiredOfflineObjectRemover } from '../../abstract/expired-offline-object-remover';
import { OfflineTaskChangesObject } from './offline-task-changes-object';

export class ExpiredTaskChangesRemover extends ExpiredOfflineObjectRemover<
  number,
  OfflineTaskChangesObject
> {}
